export default {
  GET: `#graphql
  query getStock {
    getStock
    { 
      product,
      sizes,
      tiers,
      quantityAvailable
    }            
  }`,

  GET_ONE: `#graphql
  query getOneStock($product: String!) {
    getOneStock(product: $product)
    { 
      product,
      sizes,
      tiers,
      quantityAvailable
    }            
  }`,

  UPDATE: `#graphql
  mutation updateStock($input: [ProductStockInput]!) {
    updateStock(input: $input)
    { 
      product,
      success,
      error
    }            
  }`,

  ADD: `#graphql
  mutation addStock($input: [ProductStockInput]!) {
    addStock(input: $input, fromTemporaryStock: true)
    { 
      product,
      success,
      error
    }            
  }`,

  SUBTRACT: `#graphql
  mutation subtractStock($input: [ProductStockInput]!) {
    subtractStock(input: $input, fromTemporaryStock: true)
    { 
      product,
      success,
      error
    }            
  }`,

  DELETE_OF_TIER: `#graphql
  mutation deleteOfTier($reference: String!, $size: String!, $tier: String!, $quantity: Int!) {
    deleteOfTier(reference: $reference, size: $size, tier: $tier, quantity: $quantity)         
  }`,

  ADD_TO_TIER: `#graphql
  mutation addToTier($reference: String!, $tier: String!, $size: String!) {
    addToTier(reference: $reference, tier: $tier, size: $size)       
  }`
}



// WEBPACK FOOTER //
// ./src/graphql/stock.js